import React, { useEffect, useRef } from "react";
import { AudioRecorder, useAudioRecorder } from "react-audio-voice-recorder";
import { Button, Flex } from "antd";
import {
  AudioOutlined,
  CloseOutlined,
  PauseOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { FaPlay } from "react-icons/fa";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import "./index.scss";

const PlayIcon = FaPlay as React.FC;

interface CustomAudioRecorderProps {
  setAudio: (url: any) => void;
  setRecording: React.Dispatch<React.SetStateAction<boolean>>;
  setAudioBlob: React.Dispatch<React.SetStateAction<File | null>>;
}

const CustomAudioRecorder: React.FC<CustomAudioRecorderProps> = ({
  setAudio,
  setAudioBlob,
  setRecording,
}) => {
  const { currentChat } = useSelector((state: RootState) => state.chat);
  const recorderControls = useAudioRecorder();
  const skipNextSave = useRef(false);

  const startRecording = () => {
    setAudio(null);
    setAudioBlob(null)
    setRecording(true);
    recorderControls.startRecording();
  };

  const addAudioElement = (blob: any) => {
    if (skipNextSave.current) {
      skipNextSave.current = false;
      return;
    }
    setAudioBlob(blob);
    const url = URL.createObjectURL(blob);
    setAudio(url);
    setRecording(false);
  };

  const cancelRecording = () => {
    if (recorderControls.isRecording) {
      skipNextSave.current = true;
      recorderControls.stopRecording();
    }

    setAudioBlob(null);
    setAudio(null);
    setRecording(false);
  };

  useEffect(() => {
    cancelRecording();
  }, [currentChat?.id]);

  return (
    <div className="audio-recorder-wrapper">
      <Button
        type="primary"
        className="audio-control-btn"
        onClick={
          recorderControls.isRecording
            ? recorderControls.stopRecording
            : startRecording
        }
        icon={
          recorderControls.isRecording ? <SaveOutlined /> : <AudioOutlined />
        }
      />
      <AudioRecorder
        onRecordingComplete={(blob) => addAudioElement(blob)}
        recorderControls={recorderControls}
        showVisualizer={true}
        classes={{
          AudioRecorderClass: "audio-recorder-container",
          AudioRecorderStartSaveClass: "hide",
          AudioRecorderPauseResumeClass: "hide",
          AudioRecorderDiscardClass: "hide",
          AudioRecorderTimerClass: "text-primary",
        }}
      />
      {recorderControls.isRecording && (
        <Flex align="center" gap={8}>
          <Button
            type="primary"
            className="audio-control-btn pause-btn"
            onClick={recorderControls.togglePauseResume}
            icon={recorderControls.isPaused ? <PlayIcon /> : <PauseOutlined />}
          />
          <Button
            type="primary"
            className="audio-control-btn cancel-btn"
            onClick={cancelRecording}
            icon={<CloseOutlined />}
          />
        </Flex>
      )}
    </div>
  );
};

export default CustomAudioRecorder;
